import moment from "moment";
export class StaffEmployHistory {
  StaffID;
  DateTx;
  JobCode;
  Title;
  Salary;
  Rem;
  AddBy;
  ModifyBy;
  constructor() {
    this.StaffID = "";
    this.DateTx = moment().format("YYYY-MM-DD");
    this.JobCode = "";
    this.Title = "";
    this.Salary = "";
    this.Rem = "";
    this.AddBy = "";
    this.ModifyBy = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffEmployHistory.js